import { GridWidget } from '../types';
import { IAsset } from '../../../types/model';

export interface EconomicCalendarProps extends GridWidget {}

// CALENDAR UI
export const VIEWS = {
  week: 'timeGridWeek',
  month: 'dayGridMonth',
} as const;

export type CALENDAR_VIEW = typeof VIEWS[keyof typeof VIEWS];

// FILTERS
export type CalendarFilter = {
  code: string;
  description: string;
  type: string;
};

// SEARCH
export type SearchResult = {
  id: string;
  name: string;
  logo: string;
  symbol?: string;
  type: 'STOCK' | 'STRATEGY';
  strategyAssets?: IAsset[];
};

// EVENTS
type SharedFields = {
  eventUrl: string;
  description: string;
  organizationName: string;
  longDescription: string;
};

export type ExtendedProps = {
  color: string;
} & SharedFields;

export interface CalendarEvent {
  id: string;
  start: Date;
  end: Date;
  title: string;
  extendedProps: ExtendedProps;
}

export type EventsApiResponse = {
  getNewsCalendar: {
    items: ({
      id: string;
      dateGmt: string;
    } & SharedFields)[];
  };
};
